// -----------------------------------------------------------------------------
//   Date and Timestamp Utilities
// -----------------------------------------------------------------------------

/**
 * Converts a value to a Date object.
 * If the value is already a Date, returns it unchanged.
 * Otherwise, creates a new Date from the string value.
 */
export function toDate(value: string | Date): Date {
    return value instanceof Date ? value : new Date(value);
}

/**
 * Converts a date value to a timestamp (number of milliseconds since epoch).
 * Returns 0 for invalid dates.
 * Useful for sorting and comparison operations.
 */
export function toTimestamp(value: string | Date): number {
    const time = value instanceof Date ? value.getTime() : new Date(value).getTime();
    return Number.isFinite(time) ? time : 0;
}

/**
 * Safe timestamp conversion with explicit error handling.
 * Alias for toTimestamp for backwards compatibility.
 */
export function safeTs(isoDate: string): number {
    return toTimestamp(isoDate);
}

/**
 * Formats a date into a month key string (YYYY-MM format).
 * Useful for grouping transactions by month.
 */
export function toMonthKey(d: Date): string {
    const y = d.getFullYear();
    const m = String(d.getMonth() + 1).padStart(2, "0");
    return `${y}-${m}`;
}
